import script from "./SemiCustom.vue?vue&type=script&setup=true&lang=js"
export * from "./SemiCustom.vue?vue&type=script&setup=true&lang=js"

import "./SemiCustom.vue?vue&type=style&index=0&id=2888b828&scoped=true&lang=css"

import exportComponent from "C:\\laragon\\www\\karuizawa\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2888b828"]])

export default __exports__